<template>
    <div class="input-group-container has-value">
        <div class="input-group" :class="{ error: validation ? validation.$error : false }">
            <label :for="`form-input-${name}`" class="input-group-title has-icon">{{ title }}</label>
            <div v-if="prependIcon" class="input-icon-prepend">
                <NuxtIcon name="ri:arrow-down-s-line" />
            </div>
            <div v-if="appendIcon" class="input-icon-append">
                <NuxtIcon :name="`ri:${appendIcon}`" />
            </div>
            <select
                :id="`form-input-${name}`"
                v-model="updatedValue"
                :name="name"
                :data-tooltip="tooltip"
                :class="{ 'non-value-selected': nonSelected }"
            >
                <option v-if="defaultOption" disabled :selected="!value?.length" value="">{{ defaultOption }}</option>
                <option
                    v-for="option in options"
                    :key="option.value"
                    :value="option.value"
                    :disabled="option.disabled"
                    :selected="(typeof value === 'object' ? value.value : value) === option.value"
                >
                    {{ option.label }}
                </option>
            </select>
            <div v-if="tooltip" class="tooltip">{{ tooltip }}</div>
            <div v-if="validation && validation.$error && validation.required.$invalid" class="error-tooltip">
                {{ validation.required.$message }}
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { config } from '@vue/test-utils';

const { value, options, defaultOption }: any = defineProps({
    name: { type: String, required: true, default: 'Sleep' },
    title: { type: String, required: true, default: 'Title' },
    tooltip: { type: String, required: false },
    options: { type: Object, required: true, default: () => ({}) },
    defaultOption: { type: String, required: false },
    value: { type: [String, Number], required: false },
    prependIcon: { type: String, required: false, default: '' },
    appendIcon: { type: String, required: false, default: 'arrow-down-s-line' },
    validation: { type: Object, required: false, default: null },
});

const updatedValue = ref(value);
const nonSelected = ref(true);

watch(updatedValue, (newVal) => {
    emit(
        'update:value',
        options.find((option) => option.value === newVal)
    );
    nonSelected.value = !updatedValue.value;
});

watch(
    () => value,
    (newVal) => {
        updatedValue.value = newVal;
    }
);

// Constant variable for initialising emit events
const emit = defineEmits<{
    (e: 'update:value', value: string): void;
}>();
onMounted(() => {
    nonSelected.value = !updatedValue.value;
});
</script>

<style lang="postcss" scoped>
select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    text-indent: 1px;
}
</style>
